import axios from 'axios';
import IMG_DEFAULT_PRODUCT from '../assets/img/default_product.png';
import { BASE_PATH_PORTAL } from 'constants/env';

export function repareImage(urlImage) {
  const urlImageData = new URL(urlImage);
  return urlImage?.length >= 1
    ? urlImage.replace(urlImageData.origin, BASE_PATH_PORTAL)
    : urlImage;
}

const getAddressURL = ({
  calle,
  numeroExterior,
  colonia,
  codigoPostal,
  ciudad,
  estado,
}) =>
  encodeURIComponent(
    `${calle} ${numeroExterior} ${colonia} ${codigoPostal} ${ciudad} ${estado} México`
  );

export const validateExitsImage = async (urlImg) => {
  try {
    const blob = await axios({
      url: urlImg,
      method: 'GET',
    });
    return blob.data.length > 0 && blob.headers['content-type'].includes("image");
  } catch (e) {
    console.log('error validateExitsImage', e.message);
  }
};

export const setterDefaultImages = async (images) => {
  let cont = 0;
  const newImages = [];
  while (cont < images.length) {
    const image = images[cont];
    image.original = repareImage(image.source || image.original);
    image.thumbnail = repareImage(image.thumbnail);
    const validimage = await validateExitsImage(image.original);
    if (!validimage) {
      newImages.push({
        ...image,
        original: IMG_DEFAULT_PRODUCT,
        thumbnail: IMG_DEFAULT_PRODUCT,
      });
    } else {
      newImages.push(image);
    }
    cont += 1;
  }
  !newImages.length && newImages.push({
    original: IMG_DEFAULT_PRODUCT,
    thumbnail: IMG_DEFAULT_PRODUCT,
  });
  return newImages;
};

export { getAddressURL };
